import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

class WindowMessage extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { 
      usedLimitAUG,
      totalLimitAUG,
      usedLimitAGG,
      totalLimitAGG,
      windowStartTime,
      windowEndTime,
    } = this.props;

    let startDate = '';
    let endDate = '';

    if (windowStartTime) {
      startDate = moment(windowStartTime).format('LLL');
    }
    if (windowEndTime) {
      endDate = moment(windowEndTime).format('LLL');
    }

    return (
      <>
        <h2 style={{marginTop: 0}}>
          Precious Metals Trading Window
        </h2>
        <p>
          If you miss your window, or your portfolio&apos;s volume exceeds the window&apos;s allotment, you will be assigned another window later.
        </p>
        <p>
          <b>Window Start</b>: {startDate || ''}
        </p>
        <p>
          <b>Window End</b>: {endDate || ''}
        </p>
        <p>
          <b>Remaining Gold (g)</b>: {usedLimitAUG || ''} / {totalLimitAUG || ''}
        </p>
        <p>
          <b>Remaining Silver (g)</b>: {usedLimitAGG || ''} / {totalLimitAGG || ''}
        </p>
      </>
    );
  }
}

export default withRouter(WindowMessage);
